export const UI_USER = 'Mercury_UI'

export const EDI_FORMATS = {
  EDI: 'edi',
  PRETTY: 'pretty',
}
